import React from 'react';
import { NavLink } from 'react-router-dom';

import { NavigationList } from './style';
const Navigation = () => (
    <nav>
        <NavigationList>
            <li><NavLink to="/home" activeClassName='active-nav'>Home</NavLink></li>
            <li><NavLink to="/section/politics" activeClassName='active-nav'>Politics</NavLink></li>
            <li><NavLink to="/section/fashion" activeClassName='active-nav'>Fashion</NavLink></li>
            <li><NavLink to="/section/tech" activeClassName='active-nav'>Tech</NavLink></li>
            <li><NavLink to="/section/science" activeClassName='active-nav'>Science</NavLink></li>
        </NavigationList>
    </nav>
);

export default Navigation;